import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import selectionsStore from "src/stores/selections";
import { usePrevious } from "src/hooks/previous";
import { PriceChangeEnum } from "src/constants/enums/priceChange";
import mainStore from "../stores/main";
import { ISelection } from "src/constants/interfaces/bet";

const checkIsOddChanged = (
	selections: ISelection[],
	prevSelections: ISelection[],
	priceChangeType: PriceChangeEnum
) => {
	if (selections.length !== prevSelections.length || priceChangeType === PriceChangeEnum.AcceptAnyOdds)
		return false;

	return priceChangeType === PriceChangeEnum.AlwaysAsk
		? selections.some(
				(item, index) =>
					!item.event.isRacingEvent &&
					item.event.price !== prevSelections[index].event.price
		  )
		: selections.some(
				(item, index) =>
					!item.event.isRacingEvent &&
					item.event.price < prevSelections[index].event.price
		  );
};

export const useAcceptPriceChange = (): [boolean, () => void] => {
	const [isAccepted, setIsAccepted] = useState(true);

	const { selections } = useRecoilValue(selectionsStore);
	const prevSelections = usePrevious(selections);

	const { priceChangeType } = useRecoilValue(mainStore);

	useEffect(() => {
		if (prevSelections && isAccepted) {
			const oddChanged = checkIsOddChanged(selections, prevSelections, priceChangeType);

			oddChanged && setIsAccepted(false);
		}
	}, [prevSelections, selections, priceChangeType, isAccepted]);

	const acceptPriceChange = () => setIsAccepted(true);

	return [isAccepted, acceptPriceChange];
};
